import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

import { Link } from "react-router-dom";
import _ from "underscore";

var BookDisplay = require("components/reading/books/BookDisplay");
var SkillsetBanner = require("components/writing/questions/SkillsetBanner");
var BookRating = require("components/reading/books/BookRating");
var StudentAvatar = require("components/avatars/StudentAvatar");
var ReactTooltip = require("react-tooltip");

// var AnswersDisplay = require("components/reading/shelves/AnswersDisplay");
var ReviewsDisplay = require("components/reading/shelves/ReviewsDisplay");
var ExercisesDisplay = require("components/reading/shelves/ExercisesDisplay");
var CoinsEarnedDisplay = require("components/reading/shelves/CoinsEarnedDisplay");

var AltBoard = require("components/utility/AltBoard");
var ResponseModal = require("components/writing/responses/ResponseModal");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var AnswerCircle = require("components/utility/icons/AnswerCircle");
var CommentBox = require("components/social/comments/CommentBox")
var Features = require("lib/account/Features");
var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");
var AnswerAnalysisDisplay = require("components/writing/answers/AnswerAnalysisDisplay");
var MultiPartAnswerDisplay = require("components/writing/answers/MultiPartAnswerDisplay");
var WarmupQuestionsDisplay = require("components/writing/quizzes/warmups/WarmupQuestionsDisplay");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");
var LogReadingModal = require("components/reading/books/LogReadingModal")

var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var QuizDisplay = require("components/writing/quizzes/QuizDisplay");
var AnswerDisplay = require("components/writing/answers/AnswerDisplay");
var ExerciseTile = require("components/writing/activities/ExerciseTile");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var GradeLevel = require("lib/academic/GradeLevel");
var CurrentUser = require("lib/account/CurrentUser");

require("reading/shelves/expanded_book_details.scss");

@connect(
	(state, props) => {
		var book = ReadingSelectors.book({ state, id: props.textID });
		if (book) {
			var textID = book.text_id;			
		}

		if (props.studentIDs) { // Indicates class view... for now
			var students = RosterSelectors.studentsForBookTextID({ state, textID });
			var avatarsByStudentID = {};
			_.each(students, (s) => {
				avatarsByStudentID[s.id] = RosterSelectors.avatarForStudent({ state, studentID: s.id });
			});


			// Class shelf
			return {
				book,
				students, avatarsByStudentID,
				answers: WritingSelectors.nonQuizAnswers({ state, conditions: { textID, userID } }),
				reviews: WritingSelectors.reviews({ state, conditions: { textID, userID } }),
				questionBuilder:  WritingSelectors.metaCognitiveAnswers({ state, conditions: { textID, userID } })
			}

		} else {
			var userID = CurrentUser.get().id;

			// My shelf
			return {
				book,
				visibleScores: CurrentUser.get().prefs.visible_student_scores,
				quiz: WritingSelectors.quizzes({ state, conditions: { textID, userID } })[0],
				answers: WritingSelectors.nonQuizAnswers({ state, conditions: { textID, userID } }),
				reviews: WritingSelectors.reviews({ state, conditions: { textID, userID } }),
				responses: WritingSelectors.responses({ state, conditions: { textID, userID } }),
				questionBuilders:  WritingSelectors.metaCognitiveAnswers({ state, conditions: { textID, userID } })
			}
		}
	},
	(dispatch, props) => ({
		populateData: () => {

			if (props.studentIDs) { // Indicates class view... for now
				var embeds = ["book.reviews", "book.average_rating", "book.students", "student.avatar"];
				if (CurrentUser.get().prefs.answers_on_class_shelf) {
					embeds = embeds.concat(["book.answers", "answer.question"]);
				}
				var query = { user_ids: props.studentIDs };

			} else {
				var embeds = ["book.responses", "response.activity", "activity.format_summary",
					"book.answers", "answer.question", "book.reviews", "book.ratings",
					"book.quizzes", "quiz.answers", "quiz.gold_records", "answer.gold_records",
					"quiz.evaluation", "quiz.warmup_questions"];

				if (CurrentUser.get().prefs.visible_student_scores) {
					embeds = embeds.concat(["answer.evaluation", "evaluation.score_details"]);
				}

				var conditions = { allowDraft: true };
			}

			return dispatch(ReadingActions.fetchSingleBookActivity(
				{ id: props.textID, embeds, query, conditions, cache: props.textID }
			))
		}
	})
)
@providePopulateData({ waitForLoad: true })
class ExpandedBookDetails extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		LuckyOrangeClient.tagComponent("ExpandedBookDetails");
		// right now this only affects quizzes, but we could use it later for journal activities
		var showCoinDetailsModal = $wr.getURLParameterByName("showDetails") == "true";
		this.state = { 
			expandedResponse: null, showCoinDetailsModal: showCoinDetailsModal, showBookModal: false
		};
	}

	startQuestion(e) {
		$wr.nope(e);
		$wr.redirect("/answers/new?text_id=" + this.props.book.text_id);
	}
	startReview(e) {
		$wr.nope(e);
		$wr.redirect("/reviews/new?text_id=" + this.props.book.text_id);
	}
	startExercise(e) {
		$wr.nope(e);
		$wr.redirect("/responses/new?text_id=" + this.props.book.text_id);
	}
	startQuiz(e) {
		$wr.nope(e);
		$wr.redirect("/quiz?text_id=" + this.props.book.text_id);
	}
	startQuestionBuilder(e) {
		$wr.nope(e);
		$wr.redirect("/question_builder/new?text_id=" + this.props.book.text_id);
	}
	renderEmptyState(introText, buttonText, clickEvent) {
		return (
			<p className="emptySection">
				{introText}
				<a href="#" onClick={clickEvent}>{buttonText}</a>!
			</p>
		);
	}

	renderQuestionBuilderView() {
		var introText = 'Questions you build about this book go here.'
		var buttonText = ' Build a question'
		var emptyClickEvent = this.startQuestionBuilder


		if (_.isEmpty(this.props.questionBuilders)) {
			return this.renderEmptyState(introText, buttonText, emptyClickEvent)
		} else {

			var draftQuestionBuilder = _.map(_.where(this.props.questionBuilders, { draft: true }), (questionBuilder) => {

				return (
					<AnswerDisplay answerID={ questionBuilder.id } key={ questionBuilder.id } />
				)
			})

			if (CurrentUser.get().prefs.allow_student_writing_deletion) {
				var showRemove = true;
			}

			var revisionQuestionBuilder = _.map(_.where(this.props.questionBuilders, { allow_revision: true }), (questionBuilder) => {

					return (
						<AnswerDisplay
							answerID={ questionBuilder.id }
							key={ questionBuilder.id }
							viewAsStudent
							enabled={{
								lowerComments: true,
								date: true,
								editControls: showRemove,
								deletion: showRemove,
								//coinsEarned: true,
								//startRevision: true,
								//cancelRevision: true
							}}
						/>
					)
				//}
			})

			var completedQuestionBuilder = _.map(_.where(this.props.questionBuilders, { draft: false, allow_revision: false }), (questionBuilder) => {
				return (
					<AnswerDisplay
						answerID={ questionBuilder.id }
						key={ questionBuilder.id }
						viewAsStudent
						enabled={{
							lowerComments: true,
							date: true,
							editControls: showRemove,
							deletion: showRemove,
							//coinsEarned: true,
						}}
					/>
				);
			});

			return (
				<div>
					{ draftQuestionBuilder }
					{ revisionQuestionBuilder }
					{ completedQuestionBuilder }
				</div>
			);
		}
	}

	renderAnswersView() {
		var introText = 'Questions you answer about this book go here.'
		var buttonText = ' Answer a question'
		var emptyClickEvent = this.startQuestion
		if (_.isEmpty(this.props.answers)) {
			return this.renderEmptyState(introText, buttonText, emptyClickEvent)
		} else {
			var revisionAnswers = _.map(_.where(this.props.answers, { allow_revision: true }), (answer) => {
				return (
					<AnswerDisplay answerID={ answer.id } key={ answer.id }
						view="answer" viewAsStudent
						enabled={{
							score: this.props.visibleScores,
							lowerComments: true,
							date: true,
							editControls: showRemove,
							deletion: showRemove,
							coinsEarned: true,
							startRevision: true,
							cancelRevision: true,
						}} />
				);
			});

			if (CurrentUser.get().prefs.allow_student_writing_deletion) {
				var showRemove = true;
			}

			var completedAnswers = _.map(_.where(this.props.answers, { draft: false, allow_revision: false }), (answer) => {
				return (
					<AnswerDisplay answerID={ answer.id } key={ answer.id }
						view="answer" viewAsStudent
						enabled={{
							score: this.props.visibleScores,
							lowerComments: true,
							date: true,
							editControls: showRemove,
							deletion: showRemove,
							coinsEarned: true
						}} />
				);
			});

			if (_.isEmpty(revisionAnswers) && _.isEmpty(completedAnswers)) {
				return this.renderEmptyState(introText, buttonText, emptyClickEvent)
			} else {
				return (
					<div className="answersList">
						{ revisionAnswers}
						{ completedAnswers}
					</div>
				);
			}
		}
	}

	renderReviewsView() {
		var introText = "Reviews you write about this book go here. If you're done with the book,"
		var buttonText = 'write a review'
		var emptyClickEvent = this.startReview
		if (_.isEmpty(this.props.reviews)) {
			return this.renderEmptyState(introText, buttonText, emptyClickEvent)
		} else {
			if (CurrentUser.get().prefs.allow_student_writing_deletion) {
				var showRemove = true;
			}

			var completedReviews = _.map(_.where(this.props.reviews, { draft: false }), (review) => {
				return (
					<AnswerDisplay answerID={ review.id } key={ review.id } view="review" viewAsStudent
						enabled={{
							score: this.props.visibleScores,
							lowerComments: true,
							date: true,
							editControls: showRemove,
							deletion: showRemove,
							coinsEarned: true,
							startRevision: true,
							cancelRevision: true,
						}} />
				);
			})

			if (_.isEmpty(completedReviews)) {
				return this.renderEmptyState(introText, buttonText, emptyClickEvent)
			} else {
				return (
					<div className="reviewsList">
						{ completedReviews}
					</div>
				)
			}
		}
	}

	renderExercisesView() {
		var introText = "Exercises you do about this book go here. "
		var buttonText = 'Start an exercise'
		var emptyClickEvent = this.startExercise
		if (_.isEmpty(this.props.responses)) {
			return this.renderEmptyState(introText, buttonText, emptyClickEvent)
		} else {
			var responses = _.sortBy(this.props.responses, (response) => {
				return response.demo + "-" + response.completed_at;
			});
			var responseTiles = _.map(responses, (response) => {
				return (
					<ExerciseTile responseID={ response.id } key={ response.id }
						smallThumbnail allowExpandResponse />
				);
			});
			if (_.isEmpty(responseTiles)) {
				return this.renderEmptyState(introText, buttonText, emptyClickEvent)
			} else {
				return (
					<div className="responsesList">
						<AltBoard narrowBoard>
							{responseTiles}
						</AltBoard>
					</div>
				);
			}
		}
	}

	renderQuizzesView() {
		var quiz = this.props.quiz;
		var introText = "The quiz you take on this book goes here. If you're done with the book, "
		var buttonText = 'do the quiz'
		var emptyClickEvent = this.startQuiz
		if (!quiz) {
			return this.renderEmptyState(introText, buttonText, emptyClickEvent)
		} else if (quiz.draft) {
			return (
				<p className="emptySection">
					Your progress on this quiz is saved. If you're ready to do
					more, <a href="#" onClick={ this.startQuiz }>finish the quiz</a>!
				</p>
			);
		} else {
			var quiz;
			if (this.props.visibleScores && !quiz.excluded) {
				var quizScoreDisplay = (
					<ScoreDisplay subjectID={ quiz.id } subjectType="Quiz"
						showDenominator mode={ ScoreDisplay.CIRCLE_MODE } />
				);
			}

			if (this.props.view == "quizzes" && this.props.visibleScores) {
				var className = "quizzesTopRight";
			}

			var quizCoinsDisplay = (
				<CoinsEarnedDisplay subjectType="Quiz" subjectID={ quiz.id } />
			);

			if (CurrentUser.get().prefs.allow_student_writing_deletion) {
				var showRemove = true;
			}

			return (
				<div className="quizContent" >
					<div className={ "topRightContainer " + className }>
						{ quizScoreDisplay }
						{ quizCoinsDisplay }
					</div>
					<QuizDisplay quizID={ quiz.id } view={ AnswerDisplay.QUIZZES_VIEW }
						viewAsStudent
						enabled={{
							lowerComments: true,
							date: true,
							editControls: showRemove,
							deletion: showRemove,
							startRevision: true,
							cancelRevision: true,
						}} />
				</div>
			);
		}
	}

	renderDraftView() {
		var quiz = this.props.quiz;
		var reviews = _.where(this.props.reviews, { draft: true });
		var answers = _.where(this.props.answers, { draft: true });
		var responses = _.where(this.props.responses, { draft: true });
		var questionBuilders = _.where(this.props.questionBuilders, { draft: true });

		if (quiz && quiz.draft) {
			var quizContent = (
				<p className="emptySection">
					Your progress on this quiz is saved. If you're ready to do
					more, <a href="#" onClick={ this.startQuiz }>finish the quiz</a>!
				</p>
			);
		}
		if (reviews.length) {
			var reviewContent = _.map(reviews, (review) => {
				return (
					<AnswerDisplay answerID={ review.id } key={ review.id } asDraft />
				);
			})

		}
		if (answers.length) {
			var answerContent = _.map(answers, (answer) => {
				return (
					<AnswerDisplay answerID={ answer.id } key={ answer.id } asDraft />
				);
			});

		}
		if (responses.length) {
			var responseTiles = _.map(responses, (response) => {
				return (
					<ExerciseTile responseID={ response.id } key={ response.id }
						smallThumbnail allowExpandResponse />
				);
			});

			var responseContent = (
				<AltBoard narrowBoard>
					{ responseTiles }
				</AltBoard>
			);
		}
		
		if (questionBuilders.length) {
			var questionBuildContent = _.map(questionBuilders, (questionBuilder) => {
				return (
					<AnswerDisplay answerID={ questionBuilder.id } key={ questionBuilder.id } />
				);
			});
		}

		return (
			<div className="draftContent" >
				{ quizContent }
				{ reviewContent }
				{ answerContent }
				{ responseContent }
				{ questionBuildContent }
			</div>

		)
	}

	renderClassReviewsView() {
		var book = this.props.book;

		if (this.props.reviews.length == 0 && (this.props.answers == null || this.props.answers.length == 0)) {
			if (CurrentUser.isStudent()) {
				var emptyState = (
					<p>
						Nobody in your class has reviewed <em>{ book.title }</em> yet.
						If you've read it, <a href="#" onClick={ this.startReview }>write your review</a>!
					</p>
				);
			} else {
				var emptyState = (
					<p>Nobody in this class has reviewed <em>{ book.title }</em> yet.</p>
				)
			}
		} else {
			if (this.props.answers != null && this.props.answers.length > 0) {
				var bookAnswers = _.map(this.props.answers, (answer) => {
					return (
						<AnswerDisplay answerID={ answer.id } key={ answer.id }
							enabled={{
								student: true,
								date: true
							}} />

					);
				});
			} 
			if (this.props.reviews.length > 0) {
				var bookReviews = _.map(this.props.reviews, (review) => {
					return (
						<AnswerDisplay answerID={ review.id } key={ review.id }
							enabled={{
								student: true,
								date: true
							}} />

					);
				});
			}
		}
		
		return (
			<div className="classReviewsContent">
				{ emptyState }
				{ bookReviews }
				{ bookAnswers }
			</div>
		)
	}

	renderClassBookStats() {
		var book = this.props.book;
		var uniqueStudents = _.uniq(_.map(this.props.students, (student) => { return student.id }));
		var sortedStudents = $wr.sortByName(uniqueStudents, "lastName")

		var students = _.map(this.props.students, (student) => {
			var avatar = this.props.avatarsByStudentID[student.id];
			return (
				<div key={ student.id } className="studentAvatar b-tooltip" data-tip={ student.display_name }>
					<StudentAvatar student={ student } disableAnimation avatar={ avatar } maxWidth={ 30 } />
					<ReactTooltip effect="solid" />
				</div>
			)
		});

		if (book.average_rating != null) {
			var bookRating = (
				<div className="ratingContainer">
					<BookRating editable={ false } currentRating={ book.average_rating } /> <br />
				</div>
			);
		}
		return (
			<div className="bookStats">
				{ bookRating }
				<p className="readersLabel">Readers:</p>
				<div className="bookStudents">{ students }</div>
			</div>
		);
	}

	closeLogReading() {
		this.setState({ showBookModal: false });
	}

	render() {
		if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER)) {
			var fullBookContent = this.renderAnswersView();
		} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW)) {
			var fullBookContent = this.renderReviewsView();
		} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE)) {
			var fullBookContent = this.renderExercisesView();

		} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER)) {
			var fullBookContent = this.renderQuizzesView();
		} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT)) {
			var fullBookContent = this.renderDraftView();

		} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK)) {
			var fullBookContent = this.renderClassReviewsView();
			var bookStatsContent = this.renderClassBookStats();
		} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER)) {
			var fullBookContent = this.renderQuestionBuilderView();
		}

		if (CurrentUser.get().prefs.prompt_log_reading) {
			var bookModal = (
				<LogReadingModal initialBook={ this.props.book }
					open={ this.state.showBookModal } 
					key={ this.props.book.text_id }
					onClose={ this.closeLogReading } />
			);	
		}

		var showReadingLevel = CurrentUser.get().prefs.show_students_zpd_icon
			&& (this.props.view != ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK));

		return (
			<div className="expandedBookDetails" ref="content">
				<div className="bookInformationContainer">
					<BookDisplay textID={ this.props.textID } coverWidth={ 75 }
						showCover showAuthor showReadingLevel={ showReadingLevel } />
						
					{ bookStatsContent }
				</div>

				<div className="fullBookArea">
					{ fullBookContent }
				</div>
				{ bookModal }
			</div>
		);
	}
	updateHeight() {
		if (this.props.onHeightUpdated) {
			var height = $(this.refs.content).height()
			this.props.onHeightUpdated(height)	
		}		
	}
	componentDidMount() {
		this.updateHeight();
		var showBookModal = $wr.getURLParameterByName("showDetails") == "true"
		this.setState({ showBookModal: showBookModal })

		// Lord this is hacky
		this.resizeInterval = setInterval(() => {
			$wr.triggerResize()
		}, 500);
	}

	componentWillUnmount() {
		clearInterval(this.resizeInterval);
	}
}

ExpandedBookDetails.WrappedComponent.propTypes = StrictPropTypes({
	view: PropTypes.string.isRequired,
	studentIDs: PropTypes.array,
	textID: PropTypes.string,
	students: PropTypes.array,
	avatarsByStudentID: PropTypes.object,

	// Data from @connect
	book: PropTypes.object,

	quiz: PropTypes.object,
	answers: PropTypes.array,
	reviews: PropTypes.array,
	responses: PropTypes.array,
	questionBuilder: PropTypes.array,

	visibleScores: PropTypes.bool,
	onHeightUpdated: PropTypes.func, // Update css for printing
	// Handlers from @connect
	populateData: PropTypes.func
});

ExpandedBookDetails.ANSWERS_VIEW = "answers-view";
ExpandedBookDetails.REVIEWS_VIEW = "reviews-view";
ExpandedBookDetails.EXERCISES_VIEW = "exercises-view";
ExpandedBookDetails.QUIZZES_VIEW = "quizzes-view";
ExpandedBookDetails.QUESTION_BUILDER_VIEW = "question-builder-view"

ExpandedBookDetails.CLASS_REVIEWS_VIEW = "class-reviews-view";

module.exports = ExpandedBookDetails;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/ExpandedBookDetails.js